import api from '../api';

const LIST_ROLES_SUCCESS = api.events.rolesList.actionSuccess;

const defaultState = { all: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case LIST_ROLES_SUCCESS:
      return { ...state, all: action.data };
    default:
      return state;
  }
};
